var f;(function(e){e.left="left",e.right="right",e.default="left"})(f||(f={}));export{f as ButtonIconPosition};
